import { OpenAIClient, AzureKeyCredential as OpenAIAzureKeyCredential } from "@azure/openai";

export const GenerateAISummary = async (textContent, ContractType ,ContractStartDate, ContractDuration) => {
  let Summary = '';
  try {
    const AzureAI: any = JSON.parse(localStorage.getItem("AzureAI") || "{}");
    const endpoint = AzureAI?.Endpoint;
    const azureApiKey = AzureAI?.APIkey;
    const deploymentName = AzureAI?.DeploymentName;
    const openAIClient = new OpenAIClient(endpoint, new OpenAIAzureKeyCredential(azureApiKey));
    const generateSummary = async (text: string): Promise<{
      Summary: string;
      KeyvalueParagraph: string;
      Obligation: {
      title: string;
      category: string;
      description: string;
      taskType: string;
      obligationStartDate: string;
      obligationEndDate: string;
    }[];
    TagsCount: {
      risk: number;
      tax: number;
      law: number;
    };
       }> => {
    const truncatedText = text.length > 2000 ? text.substring(0, 2000) : text;
  
    const messages = [
      {
        role: "system",
        content: "You are an AI assistant that processes contracts.",
      },
      {
        role: "user",
        content: `
          1. Please summarize the following document.
          2. Extract obligations from the following contract. Format the result as a JSON array of objects with "title", "category", "description", "taskType", "obligationStartDate", and "obligationEndDate": 
          3. Count the occurrences of the following terms in the contract. Format the result as a JSON object { "risk": count, "tax": count, "law": count }.
          Make sure in response not to add extra things; only include 1., 2., 3., and 4.
          Contract Text:
          ${truncatedText}`,
      },
    ];
  
    try {
      const response = await openAIClient.getChatCompletions(
        deploymentName,
        messages,
        {
          maxTokens: 2000,
          temperature: 0.7,
        }
      );
  
      if (response.choices && response.choices.length > 0) {
        const responseText = response.choices[0].message?.content?.trim();
  
        try {
          const cleanedText = responseText
            .replace(/```json|```/g, "")
            .trim();
  
          const summaryMatch = cleanedText.match(/^1\.\s*([\s\S]*?)(?=2\.)/);
          const summary = summaryMatch
            ? summaryMatch[1].trim()
            : "No summary generated.";
  
          const keysMatch =cleanedText.match(/2\.\s*.*?\s*(\[[\s\S]*?\])/);
          let Keyvalue = [];
          if (keysMatch) {
            try {
              Keyvalue = JSON.parse(keysMatch[1]).filter(
                (item) => item.value && item.value !== "N/A"
              );
            } catch (error) {
              console.error("Error parsing Keyvalue JSON:", error);
            }
          }
          const KeyvalueParagraph = Keyvalue.map(({ key, value }) => {
            switch (key.toLowerCase()) {
              case "title":
                return `The title of this contract is ${value}.`;
                case "party a":
                  return `Party A involved in this contract is ${value}.`;
                case "party b":
                  return `Party B involved in this contract is ${value}.`;
                case "amount":
                  return `The total contract amount is ${value}.`;  
              case "contract start date":
                return `The contract starts on ${value}.`;
              case "contract end date":
                return `The contract ends on ${value}.`;
                case "contract duration":
                  return `The contract duration is ${value}.`;  
              default:
                return `The "${key}" is ${value}.`;
            }
          }).join(" ");

          const obligationsMatch = cleanedText.match(/3\.\s*.*?\s*(\[[\s\S]*?\])/);
          let Obligation = [];
          if (obligationsMatch) {
            try {
              Obligation = JSON.parse(obligationsMatch[1]);
            } catch (error) {
              console.error("Error parsing Obligation JSON:", error);
            }
          }
  
          const tagsMatch = cleanedText.match(/4\.\s*(\{[\s\S]*?\})/);
          let TagsCount = { risk: 0, tax: 0, law: 0 };
          if (tagsMatch) {
          try {
            TagsCount = JSON.parse(tagsMatch[1]);
          } catch (error) {
            console.error("Error parsing TagsCount JSON:", error);
          }
          }

          return { Summary: summary, KeyvalueParagraph, Obligation, TagsCount };
        } catch (parseError) {
          console.error("Failed to parse response as JSON:", parseError);
          throw new Error("Response format is invalid. Failed to parse the response.");
        }
      } else {
        throw new Error("No completions returned from OpenAI.");
      }
    } catch (error) {
      console.error("Error processing contract data:", error);
      throw new Error("Failed to process contract data.");
    }
      }

    if (textContent?.trim()) {
      const generatedSummary: any = await generateSummary(textContent);
      if (generatedSummary) {
        const firstDiv = `<div>This contract is between party A and Party B. Type of contract is ${ContractType.replace('.docx','')}. Duration of contract is ${ContractDuration} starting from ${ContractStartDate}.</div>`;
        const keyValueHTML = generatedSummary['KeyvalueParagraph'].trim()
          ? `<p>${generatedSummary['KeyvalueParagraph']}</p>`
          : `<p>No key-value pairs found.</p>`;
        const alltagscount = generatedSummary['TagsCount']
        const alltagscountHTML = alltagscount ? `<div style="padding-top: 10px">Here are the tags mentioned in the contract:</div>
                    <p><strong>Risk:</strong> ${alltagscount.risk} ,
                    <strong>Law:</strong> ${alltagscount.law} ,
                    <strong>Tax:</strong> ${alltagscount.tax}</p> `
              : `<div style="padding-top: 10px">Here are the tags mentioned in the contract:</div><p>No tags found.</p>`;

        // console.log(alltagscountHTML,"alltagscount")
        const obligationsHTML = generatedSummary['Obligation']?.length
          ? `<div style="padding-top: 10px">Here are the obligations mentioned in the contract:</div><ul>${generatedSummary['Obligation']?.map(
              (obligation) =>
                `<li style="padding-bottom: 10px;">
                  <strong>Title:</strong> ${obligation.title} <br />
                  <strong>Category:</strong> ${obligation.category} <br />
                  <strong>Description:</strong> ${obligation.description} 
                </li>`
            ).join('')}</ul>`
          : `<div style="padding-top: 10px">Here are the obligations mentioned in the contract:</div><p>No obligations found.</p>`;
        const summaryHTML = `<div></div>
          <div>${generatedSummary['Summary']}</div>`;
        Summary = `${firstDiv}${summaryHTML}${alltagscountHTML}${obligationsHTML}`;
      }
    } else {
      Summary = 'No meaningful content could be extracted from the document.';
    }
  } catch (error) {
    console.error('Error processing document:', error);
    Summary = null;
  }
  
  return Summary;
};